import axios from "@/api/axiosAuthRequired"
import { getAuthHeaders } from "@/api/auth"
import { BASE_URL } from "@/constants/util"

export const getUserSubscriptions = async () => {
  const url = "user/subscriptions"
  const config = {
    baseURL: BASE_URL,
    headers: getAuthHeaders(),
  }
  const res = await axios.get(url, config)
  return res.data
}

export const getUserAimlabsSubscriptions = async () => {
  const url = "user/subscriptions/aimlabs"
  const config = {
    baseURL: BASE_URL,
    headers: getAuthHeaders(),
  }
  const res = await axios.get(url, config)
  return res.data
}



// WEBPACK FOOTER //
// ./src/store/user/subscriptions/subscriptions.api.js